import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const NewList = () => {
  return (
    <ButtonWrapper>
      <Link to="/list/new">
        <Button>
          <span>Create a new list</span>
          <span>+</span>
        </Button>
      </Link>
    </ButtonWrapper>
  );
};

const ButtonWrapper = styled.div`
  a {
    text-decoration: none;
    font-weight: bold;
    color: var(--theme-secondary-color);
  }
`;

const Button = styled.div`
  font-family: sans-serif;
  background-color: var(--theme-primary-color);
  max-width: 100%;
  padding: 20px;
  border-radius: 24px;
  box-shadow: 0px 10px 20px rgba(0, 0, 0, 46%);
  display: flex;
  align-items: center;

  span {
    display: block;

    &:last-child {
      margin-left: 10px;
      font-size: 1.2rem;
    }
  }
`;
